import { MerchantTypeEnum } from './domain'

export { MerchantTypeEnum as MerchantType }

export enum PaidStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  Refunded = 'refunded',
  Refunding = 'refunding',
  PartialRefunded = 'partial_refunded',
}

export type TradeDuration = 'all' | 'last7days' | 'last14days' | 'last30days' | 'last90days'

export type TradeOrderItem = {
  name: string
  quantity: number
  unitPrice: number
  specifications: string | null
  goodsImageUrl: string | null
}

export type TradeOrder = {
  id: number
  amount: number
  paidStatus: PaidStatus
  paymentChannel: 'wxpay' | 'alipay' | null
  orderedAt: string
  paidAt: string | null
  tradeNo: string | null
  merchantOutTradeNo: string | null
  outTradeNo: string | null
  merchantNo: string | null
  transactionFee: number | null
  mockPaid: boolean
  items: TradeOrderItem[]
  sourceEntry: {
    formName: string
    formScene: string | null
  }
}

export type TradeRefund = {
  id: string
  amount: number
  status: 'processing' | 'success' | 'error'
  createdAt: string
  refundedAt: string | null
}

export type TradeOrderDetail = TradeOrder & {
  sourceEntry: {
    formToken: string | null
    formName: string | null
    formScene: string | null
    headerImageUrl: string | null
  }
  refundedAmount: number
  refundedFeeAmount: number
  refunds: TradeRefund[]
}

export type TradeBuyer = {
  name?: string
  mobile?: string
  email?: string
  address?: string | { province?: string; city?: string; district?: string; street?: string }
}

export type TradeStats = {
  transactionsAmount: number
  todayAmount: number
  ordersCount: number
  transactionsCount: number
}

export type TradePageInfo = {
  currentPage: number
  totalCount: number
  pageSize: number
}
